(function () {
  angular
    .module("akitabox.room.detail")
    .controller("RoomDetailController", RoomDetailController);

  /* @ngInject */
  function RoomDetailController(
    // Angular
    $scope,
    // Third-party
    $state,
    // AkitaBox
    models,
    // Resolve
    building,
    organization,
    room,
    // Services
    FeatureFlagService,
    NoteService,
    RoomService,
    ToastService,
    WorkOrderService,
    CreateMessageDialog,
    UserService
  ) {
    var self = this;

    var originalRoom = angular.copy(room);

    // Attributes
    self.building = building;
    self.room = room;
    self.decommissioned = room.is_decommissioned;
    self.activeTab = 0;
    self.headerActions = getHeaderActions();
    self.headerText = "";
    self.actionMenuOpen = false;

    // Details
    self.editingRoom = false;

    // Activity
    self.lastActivityItem = {
      activityType: "created-entity",
      entity: "Room",
      entity_action_html: "This <b>Room</b> was created",
      time: self.room.created_date,
    };
    self.activityParams = {
      room: self.room._id,
    };

    self.showTasks = organization.show_tasks;

    // set activity tab index based on whether or not wo tab is being displayed
    self.activityTabIndex = self.showTasks ? 2 : 1;

    // Functions
    self.selectWorkOrder = selectWorkOrder;
    self.showActivityTab = showActivityTab;
    self.showDetailsTab = showDetailsTab;
    self.showWorkOrdersTab = showWorkOrdersTab;
    self.fetchWorkOrders = fetchWorkOrders;
    self.saveNumber = saveNumber;
    self.saveName = saveName;
    self.createNote = createNote;
    self.onCancel = onCancel;
    self.addWorkOrder = addWorkOrder;
    self.addRequest = addRequest;
    self.toggleActionMenu = toggleActionMenu;

    init();

    /**
     * Initialize controller
     */
    function init() {
      setHeaderText();
      // Determine if user is allowed to make changes

      var permissions = UserService.getPermissions();

      self.readonly = !permissions.room.update;
      self.readonlyLevel = !permissions.room.update_level;
      self.canAddAttachments = permissions.room.add_attachment;
    }

    function refreshActivity() {
      $scope.$broadcast("activity:refresh");
    }

    function toggleActionMenu() {
      self.actionMenuOpen = !self.actionMenuOpen;
    }

    function addWorkOrder() {
      var params = {};

      params[models.BUILDING.ROUTE_SINGULAR] = self.building._id;
      params[models.ROOM.ROUTE_SINGULAR] = self.room._id;

      $state.go("app.workOrders.create", params);
    }

    function addRequest() {
      var params = {};

      params[models.BUILDING.ROUTE_SINGULAR] = self.building._id;
      params[models.ROOM.ROUTE_SINGULAR] = self.room._id;

      $state.go("app.serviceRequests.create", params);
    }

    function getHeaderActions() {
      var actions = [
        {
          label: "Add Message",
          icon: "message",
          action: () => {
            self.actionMenuOpen = false;
            showActivityTab();
          },
        },
      ];

      return actions;
    }

    /**
     * Navigate to work order details
     *
     * @param {Object} workOrder    The selected work order
     */
    function selectWorkOrder(workOrder) {
      $state.go("app.building.workOrder.detail", {
        accountId: self.building.cre_account,
        buildingId: self.building._id,
        workOrderId: workOrder,
      });
    }

    function showDetailsTab() {
      self.activeTab = 0;
    }

    function showWorkOrdersTab() {
      self.activeTab = 1;
    }

    function showActivityTab() {
      self.activeTab = self.activityTabIndex;
    }

    function fetchWorkOrders(skip, status) {
      var query = {
        room: self.room._id,
        status: status,
        skip: skip,
        limit: 5,
      };
      return WorkOrderService.getByBuildingId(self.room.building, query);
    }

    function saveNumber() {
      var data = { number: self.room.number };

      RoomService.updateById(self.building._id, self.room._id, data)
        .then(function () {
          originalRoom.number = angular.copy(self.room.number);
          setHeaderText();
        })
        .catch(ToastService.showError);
    }

    function saveName() {
      var data = { name: self.room.name };

      RoomService.updateById(self.building._id, self.room._id, data)
        .then(function () {
          originalRoom.name = angular.copy(self.room.name);
          setHeaderText();
        })
        .catch(ToastService.showError);
    }

    function createNote(noteText) {
      if (!noteText || !noteText.length) return;
      var data = {
        room: room._id,
        text: noteText,
      };

      return NoteService.create(building._id, data)
        .then(function () {
          // Make sure to refresh the activity to show the new note when they're done creating one
          refreshActivity();
        })
        .catch(ToastService.showError);
    }

    function onCancel(properties) {
      // Make sure they're using an array
      if (!angular.isArray(properties)) {
        return;
      }

      for (var i = 0; i < properties.length; i++) {
        var property = properties[i];

        if (
          Object.prototype.hasOwnProperty.call(self.room, property) &&
          Object.prototype.hasOwnProperty.call(originalRoom, property)
        ) {
          // reset the value back to the original only if it exist on both
          self.room[property] = originalRoom[property];
        }
      }
    }

    function setHeaderText() {
      self.headerText = "room: " + self.room.display_name;
    }
  }
})();
